module.exports = __webpack_public_path__ + "92c50e27.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/global/Header/logout.png
// module id = 930
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 16